<template>
  <v-dialog width="800" persistent :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog">
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title class="text-uppercase">Tạo sự kiện mới</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="closeDialog">close</v-icon>
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-5">
        <v-form ref="form">
          <h3 class="mb-2">1. Thông tin cơ bản</h3>
          <v-text-field
            v-model="title"
            :rules="[$rules.required]"
            label="Tiêu đề"
            placeholder="Nhập tiêu đề"
            outlined
            dense
          />
          <v-textarea v-model="description" label="Mô tả" placeholder="Nhập mô tả" outlined dense />
          <h3 class="mb-2">2. Thời gian diễn ra</h3>
          <div class="d-flex justify-space-between align-center">
            <div style="width: 40%">
              <DateIOSPicker
                :date.sync="from"
                label="Bắt đầu"
                dense
                outlined
                class="required"
                :rules="[$rules.required, $rules.date]"
              />
            </div>
            <div>---</div>
            <div style="width: 40%">
              <DateIOSPicker
                :date.sync="to"
                label="Kết thúc"
                dense
                outlined
                class="required"
                :rules="[$rules.required, $rules.date]"
              />
            </div>
          </div>

          <h3 class="my-2">3. Hạn đăng ký (không bắt buộc)</h3>
          <DateIOSPicker :date.sync="registrationDeadline" label="Hạn đăng ký" dense outlined />
          <div class="grey--text mt-1">
            Khi quá hạn đăng ký, trạng thái đăng ký sẽ tự động chuyển thành "Đóng đăng ký"
          </div>

          <h3 class="my-2">4. Đối tượng áp dụng (không bắt buộc)</h3>
          <v-select
            v-model="appliedType"
            :items="APPLIED_TYPE_SELECT_ITEMS"
            clear-icon="mdi-close"
            item-text="title"
            item-value="value"
            label="Đối tượng áp dụng"
            outlined
            dense
            clearable
            hide-details
          />
          <AutocompleteGrade
            class="mt-2"
            hide-details
            label="Chọn khối áp dụng"
            v-model="appliedForGrades"
            multiple
            v-if="appliedType === 'grade'"
          />
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn width="97px" outlined class="ma-2" @click="closeDialog">Hủy</v-btn>
        <v-spacer />
        <v-btn depressed color="primary" class="ma-2 white--text" @click="onSave">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import helpers from './helpers'
import AutocompleteGrade from '@/components/basic/input/AutocompleteGrade.vue'
export default {
  components: { DateIOSPicker, AutocompleteGrade },
  data: () => ({
    dialog: false,
    title: '',
    description: '',
    from: null,
    to: null,
    registrationDeadline: null,
    appliedType: 'all',
    appliedForGrades: [],
    appliedForStudents: [],
    APPLIED_TYPE_SELECT_ITEMS: helpers.APPLIED_TYPE_SELECT_ITEMS
  }),
  methods: {
    ...mapActions({
      create: 'events/create'
    }),
    openDialog() {
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.reset()
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    checkDeadlineValid() {
      if (this.registrationDeadline) return moment(this.to).isAfter(moment(this.registrationDeadline))
      return true
    },
    checkAppliedTypeValid() {
      if (this.appliedType === 'grade') return this.appliedForGrades.length > 0
      if (this.appliedType === 'custom') return this.appliedForStudents.length > 0
      return true
    },
    async onSave() {
      const isValid = this.$refs.form.validate()
      if (!isValid) return this.$alert.error('Vui lòng kiểm tra lại các trường đánh dấu sao')
      const isDurationValid = moment(this.to).isSameOrAfter(moment(this.from))
      if (!isDurationValid) return this.$alert.error('Ngày bắt đầu phải trước ngày kết thúc')
      const isDeadlineValid = this.checkDeadlineValid()
      if (!isDeadlineValid) return this.$alert.error('Hạn đăng ký phải nhỏ hơn ngày kết thúc')
      const isAppliedTypeValid = this.checkAppliedTypeValid()
      if (!isAppliedTypeValid) return this.$alert.error('Vui lòng chọn chi tiết đối tượng áp dụng')
      this.$loading.active = true
      try {
        await this.create({
          title: this.title,
          description: this.description,
          from: this.from,
          to: moment(this.to)
            .endOf('day')
            .toISOString(),
          registrationDeadline: moment(this.registrationDeadline)
            .endOf('day')
            .toISOString(),
          appliedType: this.appliedType,
          appliedForGrades: this.appliedForGrades.map(x => x.id).filter(Boolean)
          // appliedForStudents: this.appliedForStudents
        })
        this.$alert.success('Sửa sự kiện thành công')
        this.$emit('done')
        this.closeDialog()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
